import { RootState } from "@src/reducers/store";
import {
  updateConnectedGatewaysListData,
  updateModalsCloseDrawerModal,
} from "@src/reducers/your-reducer";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOnboardingState,
  setGatewayDetails,
} from "@src/reducers/onboarding-slice";
import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";

export const useGatewaysListRowHook = (
  gatewayData: GatewayWithSourceViewStateTypes,
) => {
  const dispatch = useDispatch();

  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.yourSlice.connectedGatewaysListData,
  );

  const toggleSourcesVisibility = () => {
    const newConnectedGatewaysListData = connectedGatewaysListData.map(
      (gateway) => {
        if (gatewayData.gateway_uuid === gateway.gateway_uuid) {
          return { ...gateway, sources_visible: !gatewayData.sources_visible };
        }
        return gateway;
      },
    );

    dispatch(updateConnectedGatewaysListData(newConnectedGatewaysListData));
  };

  const handleAddMachineClick = () => {
    dispatch(resetOnboardingState());
    dispatch(
      setGatewayDetails({
        gateway_id: gatewayData.gateway_uuid,
        name: gatewayData.name,
        vendor_id: gatewayData.vendor_id,
      }),
    );
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addNewMachineDrawerModal",
      }),
    );
  };

  return {
    toggleSourcesVisibility,
    handleAddMachineClick,
  };
};
